import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const BoxIconSvg = ({
  // color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-4.4 0 25 10.8"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        fill={iconStyle === "solid" ? "primary" : "secondary"}
        d="m9.02784 2.736c-1.24865 0-2.33521.70238-2.88243 1.73353-.54741-1.03115-1.63341-1.73353-2.88291-1.73353-.70633-.00075-1.39374.22831-1.95844.65259v-2.749026c-.00315-.170896-.07332-.333711-.19539-.453348-.122079-.1196373-.286277-.18651451-.457201-.186215-.356438 0-.64331275.284344-.651469.639563v5.413316h.00065625c.02878125 1.7774 1.47722375 3.20925 3.26184375 3.20925 1.2495 0 2.3355-.70304 2.88291-1.73316.54722 1.03012 1.63378 1.73316 2.88243 1.73316 1.80146 0 3.26286-1.46082 3.26286-3.26372 0-1.80197-1.4614-3.26241-3.26286-3.26241zm-5.76534 5.21972c-1.08103 0-1.95844-.87572-1.95844-1.95684 0-1.08075.87741-1.95657 1.95844-1.95657 1.08094 0 1.95647.87582 1.95647 1.9561 0 1.08131-.87553 1.95731-1.95647 1.95731zm5.76534 0c-1.08131 0-1.95806-.876-1.95806-1.95731 0-1.08028.87675-1.9561 1.95806-1.9561 1.08086 0 1.95716.87582 1.95716 1.9561 0 1.08131-.8763 1.95731-1.95716 1.95731z"
      />
      <Path
        fill={iconStyle === "solid" ? "primary" : "secondary"}
        d="m17.3538 8.17029-1.7735-2.17547 1.7757-2.17968c.2245-.28753.1601-.68907-.1498-.90235-.3103-.21515-.7457-.16003-.9858.11897v-.00037l-1.5277 1.87237-1.5264-1.87237v.00037c-.2376-.279-.6757-.33412-.9851-.11897-.3094.21347-.3741.61482-.1484.90235h-.0007l1.7727 2.17968-1.7727 2.17547h.0007c-.2257.28847-.161.68869.1484.90291s.7475.15966.9851-.11972l1.5264-1.86975 1.5256 1.86975c.2403.27938.6755.33394.9858.11972.3101-.21422.3747-.61444.1497-.90291z"
      />
    </Svg>
  )
}

export default BoxIconSvg
